<template>
  <q-dialog v-model="shown">
    <q-card style="width: 400px;">
      <q-form
        ref="formRef"
      >
        <q-card-section class="row items-center q-mx-xs">
          <div class="text-h6">
            Create Library Site
          </div>
          <q-space />
          <q-btn
            v-close-popup
            icon="close"
            flat
            round
            dense
          />
        </q-card-section>
        <q-card-section>
          <div class="text-body1">
            This will take several minutes and cannot be reverted.
          </div>
        </q-card-section>
        <q-card-section>
          <div
            class="row"
          >
            <q-btn
              size="lg"
              class="col-12"
              color="negative"
              label="Create Library Site"
              :loading="creating"
              @click="create"
            />
          </div>
        </q-card-section>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

export default {
  name: 'CreateLibrarySiteDialog',
  mixins: [FormValidationMixin],
  props: {
    modelValue: {
      type: Boolean,
      required: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false,
      creating: false
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  models: {
    developer: {
      immediate: true
    }
  },
  methods: {
    create () {
      this.validateForm(async () => {
        this.creating = true

        this.developer.action = 'create_library_site'
        const result = await this.developer.save()

        if (result.errors && result.errors.length) {
          this.$mh.showErrors(result.errors)
          this.creating = false
          return
        }

        await this.$handleAuthChange()

        this.creating = false
        this.shown = false
      })
    }
  }
}

</script>
